/** @deprecated Unified config is now always enabled. Will be removed with IX-1575. */
export function isUnifiedConfigEnabled(): boolean {
    return true;
}
